import gql from 'graphql-tag';

export const ORGANIZATION_DETAILS = gql`
  query organizationDetails {
    organizationDetails {
      id
      logo
      contactEmail
      name
      active
      hasMember
      slug
      showFirstSteps
      domain
      public
      freeTrial
      freePlan
      freeTrialExpires
      organizationRole {
        name
      }
      integration {
        type
        status
        createdAt
        updatedAt
        asSaas
      }
    }
  }
`;

export type OrganizationDetailsQuery = {
  organizationDetails: Organization;
};
